import mixpanel from "mixpanel-browser";

export default function trackPage(page: string) {
  // this 100% exists https://docs.mixpanel.com/docs/tracking/reference/javascript#tracking-page-views
  // the types are just wrong
  // FIXME: get the types working
  (mixpanel as any).track_pageview({
    page,
    $ip: "$remote_ip",
  });

  // register a super property for the first time only
  mixpanel.register_once({
    "First Login Date": new Date().toISOString(),
  });
}
